import { WorkerVersionStatusToPillVariantMapping } from "#src/view-models/workers";
import { UserDataDisplay } from "#src/components/Common/UserDataDisplay";
import {
  DateDataDisplay,
  ListCard,
  Pill,
} from "@validereinc/common-components";
import {
  type UserReturnType,
  type WorkerVersionType,
} from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import classNames from "classnames/bind";
import React from "react";
import styles from "./WorkerVersionCard.module.scss";

const cx = classNames.bind(styles);

type WorkerVersionCardProps = {
  version: WorkerVersionType;
  isSelected: boolean;
  latestVersionNumber?: number;
  metadataUsersMap: Record<string, UserReturnType>;
  onSelect: (versionNumber: number) => void;
};

export const WorkerVersionCard = ({
  version,
  isSelected,
  latestVersionNumber,
  metadataUsersMap,
  onSelect,
}: WorkerVersionCardProps) => (
  <ListCard
    as="li"
    isSelected={isSelected}
    hasBorderBottom
    renderTitle={({ FieldSegment }) => (
      <FieldSegment>
        <span className={cx("version-title-with-status")}>
          <span>
            v{version.version}
            {latestVersionNumber === version.version ? " (Current)" : ""}
          </span>
          <Pill
            variant={
              WorkerVersionStatusToPillVariantMapping[version.status] ??
              "default"
            }
            hasDot={false}
          >
            {toTitleCaseString(version.status, {
              intent: "ui",
            })}
          </Pill>
        </span>
      </FieldSegment>
    )}
    renderMeta={({ FieldSegment }) => (
      <FieldSegment>
        Created{" "}
        <DateDataDisplay
          value={version.created_at}
          isInline
        />
        {metadataUsersMap && version.created_by ? (
          <>
            {" "}
            by{" "}
            <UserDataDisplay
              isInline
              sizeVariant="small"
              id={version.created_by}
              name={metadataUsersMap[version.created_by]?.name}
            />
          </>
        ) : (
          ""
        )}
      </FieldSegment>
    )}
    onClick={() => {
      onSelect(version.version);
    }}
  />
);
